import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TipoComissao } from '~/constant';
import {
  format,
  formatarMonetario,
  definirStatusComissao,
} from '~/Utils/Helpers';

const renderBadgeStatusComissao = (comissaoCancelada, comissaoBaixada) => {
  const status = definirStatusComissao(comissaoCancelada, comissaoBaixada);
  const badgeClass = {
    Cancelada: 'badge-danger',
    Recebida: 'badge-success',
    'A receber': 'badge-warning',
  };

  return (
    <span
      className={`badge ${badgeClass[status] || 'badge-secondary'}`}
      style={{ fontSize: '12px' }}
    >
      {status}
    </span>
  );
};

const ModalComissao = ({ linhaSelecionada }) => {
  const statusComissao = definirStatusComissao(
    linhaSelecionada.comissao_cancelada,
    linhaSelecionada.comissao_baixada
  );
  const getTipoComissao = tipo => {
    const tipos = {
      1: 'Padrão',
      2: 'Especial',
      3: 'Bonificação',
    };
    return tipos[tipo] || '-';
  };

  const getTipoCalculoComissao = tipo => {
    const tipos = {
      1: 'Valor Fixo',
      2: 'Percentual',
    };
    return tipos[tipo] || '-';
  };

  return (
    <div className="mt-1">
      <h5 className="text-center text-secondary">Informações da Comissão</h5>
      <Row className="mt-3">
        <Col md={3}>
          <small>Último Vencimento (sinal):</small>
          <br />
          <strong>
            {format.date(linhaSelecionada.data_ultimo_vencimento_sinal)}
          </strong>
        </Col>
        <Col md={3}>
          <small>Tipo Cálculo Comissão:</small>
          <br />
          <strong>
            {linhaSelecionada.tipo_calculo_comissao === 1
              ? 'Valor Fixo'
              : 'Percentual'}
          </strong>
        </Col>
        <Col md={3}>
          <small>Valor base cálculo:</small>
          <br />
          <strong>
            {linhaSelecionada.tipo_calculo_comissao === 1
              ? formatarMonetario(linhaSelecionada.valor_base_comissao)
              : linhaSelecionada.valor_base_comissao + '%'}
          </strong>
        </Col>
        <Col md={3}>
          <small>Status da Comissão:</small>
          <br />
          {renderBadgeStatusComissao(
            linhaSelecionada.comissao_cancelada,
            linhaSelecionada.comissao_baixada
          )}
        </Col>
      </Row>
      <Row className="mt-1">
        <Col md={3}>
          <small>Pré-venda:</small>
          <br />
          <strong>{linhaSelecionada.pre_venda}</strong>
        </Col>
        <Col md={3}>
          <small>Sinal:</small>
          <br />
          <strong>{formatarMonetario(linhaSelecionada.valor_sinal)}</strong>
        </Col>

        <Col md={3}>
          <small>Parcelas de Sinal:</small>
          <br />
          <strong>{linhaSelecionada.quantidade_parcelas_sinal}</strong>
        </Col>

        <Col md={3}>
          <small>Parcelas Pagas de Sinal:</small>
          <br />
          <strong>{linhaSelecionada.quantidade_parcelas_sinal_pagas}</strong>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col md={3}>
          <small>
            {(() => {
              switch (statusComissao) {
                case 'A receber':
                  return 'Comissão a Receber:';
                case 'Recebida':
                  return 'Comissão Recebida:';
                case 'Cancelada':
                  return 'Comissão Cancelada:';
              }
            })()}
          </small>
          <br />
          <strong>
            {(() => {
              switch (statusComissao) {
                case 'A receber':
                case 'Recebida':
                  return formatarMonetario(linhaSelecionada.valor_comissao);
                case 'Cancelada':
                  return formatarMonetario(
                    linhaSelecionada.valor_comissao_cancelada
                  );
              }
            })()}
          </strong>
        </Col>
        <Col md={3}>
          <small>Tipo Comissão:</small>
          <br />
          <strong>
            {(() => {
              switch (linhaSelecionada.tipo_comissao) {
                case TipoComissao.RetidaCorretor:
                  return 'Retida Corretor';
                case TipoComissao.ComissaoContrato2:
                  return 'Comissão contrato 2';
              }
            })()}
          </strong>
        </Col>
        <Col md={3}>
          <small>
            {' '}
            {(() => {
              switch (statusComissao) {
                case 'A receber':
                  return 'Data Próx. Pagamento (comissão):';
                case 'Recebida':
                case 'Cancelada':
                  return 'Pago em (comissão):';
              }
            })()}
          </small>
          <br />
          <strong>
            {format.date(linhaSelecionada.data_proximo_pagamento)}
          </strong>
        </Col>
        <Col md={3}>
          <small>Corretor: </small>
          <br />
          <strong>{linhaSelecionada.corretor}</strong>
        </Col>
      </Row>
      {linhaSelecionada.tem_refinanciamento === 1 && (
        <>
          <hr className="my-2" />
          <h5 className="text-center text-secondary">
            Informações do Refinanciamento
          </h5>
          <Row className="mt-3"></Row>
        </>
      )}
    </div>
  );
};

export default ModalComissao;
